module.exports = __webpack_public_path__ + "static/media/logo159.2811aecc.png";